<div class="empty-record" *ngIf="!loaderService.isLoading">
  <img
    src="https://storage.googleapis.com/dev-ps-asset/ps_icons/no-record-found.png"
    alt=""
    *ngIf="!disableImage"
  />
  <div class="title-f">{{ title }}</div>
  <div class="desc-f" *ngIf="!disableSubTitle">Add a new record now!</div>
</div>
